var map = {
	"./email-icon.svg": [
		447
	],
	"./message-icon.svg": [
		448
	],
	"./mgm-banner-start.svg": [
		444
	],
	"./mgm-link-icon.svg": [
		445
	],
	"./mgm_thumbnail_cl.png": [
		1276,
		17
	],
	"./mgm_thumbnail_default.png": [
		443
	],
	"./whatsapp-icon.svg": [
		446
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1240;
module.exports = webpackAsyncContext;